<template>
  <div class='treasure_con'>
    <div class='flex_con'>
      <div class="back-btn">
        <el-button @click="$router.go(-1)">返回</el-button>
      </div>
      <div class='flex1'>
        <mer-steps :stepConfig="stepConfig" :currentStep="currentStep"></mer-steps>
        <div v-show="currentStep === 1" class='form_con' :activeType="9" ref="first" >
          <el-form ref="form" :model="form" label-width="98px" :rules="rules">
            <el-form-item label="活动时间" prop="beginTime">
              <el-date-picker
                v-model="form.beginTime"
                type="date"
                value-format='yyyy-MM-dd HH:mm:ss'
                @change="onChangePayTime"
                :picker-options='pickerOptions'
                placeholder="请选择开始时间">
              </el-date-picker>
              至
              <el-date-picker
                v-model="form.endTime"
                type="date"
                disabled
                placeholder="请选择结束时间">
              </el-date-picker>
            </el-form-item>
            <div class="el-form-item-box">
              <div class='form_lable'>收货信息</div>
              <div class="form_info">* 活动达标后，将为您邮寄奖品，请务必正确填写您的收货信息</div>
            </div>
            <div class='form_box_shadow'>
              <el-form-item label="收货人" prop="receiver">
                <el-input type="text" v-model="form.receiver" maxlength="4" placeholder="请使用真实姓名"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="receiverPhone">
                <el-input type="text" v-model="form.receiverPhone" placeholder="收货人电话号码"></el-input>
              </el-form-item>
              <el-form-item label="收获地址" prop="address">
                <div class="flex_div">
                  <addressSelect @change='changeAddress' :defaultData='defaultData' :required='true' />
                </div>
              </el-form-item>
              <el-form-item label="" prop="receiverAddress" style="margin-top: -10px;">
                <el-input type="textarea" maxlength="50" :rows="3" v-model="form.receiverAddress" placeholder="详细地址"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div v-show="currentStep === 2" class='result_box'>
          <div class='res_left'>
            <img class='success_icon' src="http://web.nlktj.com/ty/merchant/success_icon.png" alt="">
            <p class='sign_success'>报名成功</p>
            <div class='sign_info'>活动到开始时间时若仍未审核通过，活动将自动失效</div>
            <div class='sign_info' v-if='md.salePhone'>您可联系<span class='sign_warn'>MD「{{md.userName}}」-「{{md.salePhone}}」</span>加急审核</div>
            <div class='btns'>
              <el-button @click='goBack'>返  回</el-button>
              <el-button type="primary" @click="toCheckPage">查看审核</el-button>
            </div>
          </div>
          <div class='res_right'>
            <p class='qrcode_title'>拉新二维码</p>
            <img class="qrcode_img" :src="qrcode" alt="">
            <p class='qrcode_info'>审核通过后拉新即可享受达标权益快去拉新赢大奖吧！</p>
            <a @click="encode" download="撬装油站.png" class="down-load">下载二维码</a>
          </div>
        </div>
      </div>
    </div>

    <!--底部按钮-->
    <div class="btn-wrap" v-show="currentStep === 1">
      <div class='flex_center'>
        <el-checkbox v-model="haveRead" @change="readChange">我已知悉并认同</el-checkbox>
        <span class="protal" @click.stop="openToggleProtocol">《抽奖宝活动协议》</span>
      </div>
      <div class='flex_center'>
        <el-button @click="cancelFn">取消</el-button>
        <el-button type="primary" @click="next" v-loading="loading">下一步</el-button>
      </div>
    </div>

    <el-dialog
      title="抽奖宝商户活动规则"
      :visible.sync="toggleProtocol"
      :center="true"
      @close='close'
      width="650px"
      style="border-radius: 4px;"
      >
      <div class='protocol'>
        <p >为维护加油站（“商户”）的合法权益，团油特制定本“抽奖宝活动规则”，请商户仔细阅读、充分理解本规则的各项内容。商户参与本活动的，即视为同意遵守本规则的所有内容。</p>
        <br/>
        <p>（一）活动介绍</p>
        <p>抽奖宝活动是团油针对合作加油站推出的营销推广活动。参与活动的加油站按照本活动规则完成活动任务后，可以获得对应的奖励。</p>
        <p>（二）活动时间</p>
        <p>报名时间：2021年8月1日00:00:00-2022年8月1日00:00:00 </p>
        <p>如后续活动延续或规则变更，会通过官方系统、活动页面等方式予以公告公布或通知，敬请关注。</p>
        <p>活动时间：商户报名参加活动后，自行设置活动开始时间，活动连续{{cycle}}</p>
        <p>（三）活动规则</p>
        <p>1、在报名时间内，商户可随时报名参加活动；成功报名活动的商户视为活动商户。</p>
        <p>2、商户报名后，应及时自行设置活动开始时间；活动周期为{{cycle}}，活动结束后，若商户完成活动任务的，即可获得对应的奖励。</p>
        <p>3、参与活动商户每邀请一名新用户使用团油APP在其加油站完成一笔{{drawConditionType}}金额不小于{{drawConditionMoney}}元的加油订单，视为完成一次有效邀请。</p>
        <p>注：</p>
        <p>（1）新用户指未通过团油平台进行过加油交易的用户；同一个团油账号、手机号、移动设备、银行卡、身份证以及其他信息相同均视为同一账号，在本活动中，按一名用户计算。</p>
        <p>（2）增量参考值=商户报名的前14天内油站新用户总数 ÷ 产生新用户的天数假设商户参与活动前14天内每天有新用户，则除以14 ；假设只有7天有新用户，则除以7。</p>
        <p>（3）每日新用户增量 = 当日新用户数 - 增量参考值</p>
        <p>（四）奖励规则</p>
        <p>1、依据商户完成有效邀请的数量情况，获得对应的活动奖励。</p>
        <p>具体奖励规则，以活动页面展示的内容为准。</p>
        <p>2、商户达到奖励标准后，可按照活动页面提示申请兑换相应奖品。</p>
        <p>3、实物类奖品需按照页面提示准确填写相关收件信息，商户提交收件信息后，实物奖品会在15个工作日内进行发放。</p>
        <p>（五）活动其他说明</p>
        <p>1、以下行为视为无效邀请：</p>
        <p>（1）退款；</p>
        <p>（2）违法违规、作弊行为（包括刷信、刷单、虚假交易等）、不道德行为（比如避免滥发推广、扰乱公共秩序、非正当宣传），团油有权单方对涉嫌违规、作弊交易做出判断。</p>
        <p>2、如果活动商户存在或涉嫌违法违规行为情况（包括不限于虚假交易、作弊、套现、其他风险等）的，团油将撤销该商户活动参与资格，并有权回收已经获得的奖励等利益。</p>
        <p>3、为保证活动长期、健康发展，商户推荐客户时，须避免采取滥发短信、邮件等骚扰行为，未经授权不能在推广时使用“团油”作为推广信息签名；在推广本活动过程中，商户须认真阅读本活动规则并向客户就本活动做明确的说明和解释，以便客户对本活动有明确感知和充分理解；如邀请者张贴本活动的宣传海报，须遵守涉及广告、物料宣传的法律法规，环境保护法律法规以及相关地方政策规定；如商户未遵守上述规定导致被投诉、处罚或造成不良影响的，团油将采取相关措施直至撤销活动参与资格。</p>
        <p>4、团油如因市场、运营等实际情况，团油有权对活动规则进行变更，需要对本活动规则作变更时，将通过官方系统、活动页面等方式予以公告公布或通知。</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import validator from '@/utils/validate'
import merSteps from '@/components/work/MerStep'
import addressSelect from '@/components/work/AddressSelect'
import { getEffectiveLuckDrawByGasId, getBlueQRcode, getAgreementValue, signUp, getMdByGas, getLastAddress } from '@/api/marketPromotion/index.js'
export default {
  components: { merSteps, addressSelect },
  data () {
    return {
      stepConfig: [
        { step: 1, title: '填写信息' },
        { step: 2, title: '报名完成' }
      ],
      qrcode: 'http://web.nlktj.com/ty/merchant/voice-robot.png',
      qrcodeBase: '',
      toggleProtocol: false,
      currentStep: 1,
      defaultData: {},
      form: {
        beginTime: '',
        endTime: '',
        receiver: '',
        receiverPhone: '',
        address: '',
        receiverAddress: '',
        receiverProvince: '',
        receiverCity: '',
        receiverArea: ''
      },
      loading: false,
      haveRead: false,
      ruleId: '',
      cycleNum: 7,
      cycle: '7',
      cycleCompanyType: '',
      drawConditionType: '',
      drawConditionMoney: 100,
      md: {
        userName: '',
        salePhone: ''
      },
      rules: {
        beginTime: [
          { required: true, message: '请选择开始时间', trigger: 'blur' }
        ],
        receiver: [
          { required: true, message: '请填写收货人姓名', trigger: 'blur' },
          { pattern: /^[A-Za-z\u4e00-\u9fa5]+$/, message: '请填写正确姓名', trigger: 'blur' }
        ],
        receiverPhone: [
          { required: false, message: '请填写收货人号码', trigger: 'blur' }
        ],
        receiverAddress: [
          { required: true, message: '请填写详细地址', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '请输入正确地址', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请选择省市区', trigger: 'blur' },
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          let curDate = Date.now()
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          // let day = 1 * 24 * 3600 * 1000
          let day6 = 6 * 24 * 3600 * 1000
          let dateRegion = curDate
          let maxDate = curDate + day6
          return time.getTime() > maxDate || time.getTime() < dateRegion
        }
      }
    }
  },
  created () {
  },
  mounted () {
    this.$track.pageViewEvent('营销推广-营销中心-抽奖宝-报名填写页', '1627892950')
    this.getInfo()
    this.getLastAddressFn()
    this.getAgreementValueFn()
    this.getMdByGasFn()
  },
  methods: {
    close () {
      this.toggleProtocol = false
    },
    async getLastAddressFn () {
      const { code, result } = await getLastAddress({})
      if (code !== 200 || !result) return
      this.form.receiverAddress = result.address
      this.form.receiver = result.receiver
      this.form.receiverPhone = result.receiverPhone

      if (this.form.receiverProvince && this.form.receiverCity && this.form.receiverArea) {
        this.form.address = this.receiverProvince + this.receiverCity + this.receiverArea + ''
      }
      this.defaultData = {
        provinceCode: result.province,
        cityCode: result.city,
        countyCode: result.area
      }
      this.form.receiverProvince = result.province,
      this.form.receiverCity = result.city
      this.form.receiverArea = result.area
      console.log('form', this.form)
    },
    async getAgreementValueFn () {
      const { code, result } = await getAgreementValue({})
      if (code !== 200) return
      this.cycle = result.cycle
      this.drawConditionType = result.drawConditionType,
      this.drawConditionMoney = result.drawConditionMoney
    },
    async getInfo () {
      const { code, result} = await getEffectiveLuckDrawByGasId({})
      if (code !== 200) return
      this.ruleId = result.ruleId
      this.cycleNum = result.cycleNum
      this.cycleCompanyType = result.cycleCompanyType
    },
    async getMdByGasFn () {
      const { code, result } = await getMdByGas({})
      if (code !== 200) return
      this.md = result || {}
    },
    async getBlueQRcodeFn () {
      const { code, result } = await getBlueQRcode({})
      if (code !== 200) return
      this.qrcode = result
    },
    changeAddress (val) {
      console.log('val', val)
      this.form.receiverProvince = val.provinceCode,
      this.form.receiverCity = val.cityCode
      this.form.receiverArea = val.countyCode
      if (this.form.receiverProvince && this.form.receiverCity && this.form.receiverArea) {
        this.form.address = this.receiverProvince + this.receiverCity + this.receiverArea + ''
      }
    },
    async signUpFn (params) {
      this.loading = true
      const { code, message } = await signUp(params)
      this.loading = false
      if (code !== 200) return this.$message.error(message)
      this.getBlueQRcodeFn()
      this.currentStep = 2
    },
    next () {
      this.$track.clickEvent('营销推广-营销中心-抽奖宝-报名填写页', '1627892951', { tysj_trade_type: 1 })
      console.log(this.form)
      if (this.form.receiverPhone && !(/^1[3456789]\d{9}$/.test(this.form.receiverPhone))) return this.$message.error('请输入正确的手机号')
      this.$refs.form.validate(valid => {
        if (valid) {
          // let params = JSON.parse(JSON.stringify(this.form))
          if (!this.haveRead) return this.$message.error('请勾选协议')
          // 提交接口
          let params = {
            ruleId: this.ruleId,
            beginTime: this.form.beginTime,
            receiver: this.form.receiver,
            receiverAddress: this.form.receiverAddress,
            receiverArea: this.form.receiverArea,
            receiverCity: this.form.receiverCity,
            receiverPhone: this.form.receiverPhone,
            receiverProvince: this.form.receiverProvince
          }
          this.signUpFn(JSON.parse(JSON.stringify(params)))
        }
      })
    },
    cancelFn () {
      this.$track.clickEvent('营销推广-营销中心-抽奖宝-报名填写页', '1627892951', { tysj_trade_type: 2 })
      this.$router.go(-1)
    },
    onChangePayTime (val) {
      console.log('time=>', val)
      if (!val) {
        this.form.endTime = ''
        return false
      }
      if (this.cycleCompanyType === 2) { // zhou
        this.form.endTime = Date.parse(new Date(val)) + (this.cycleNum) * 24 * 3600 * 1000 * (7 - 1)
      } else { // ri
        this.form.endTime = Date.parse(new Date(val)) + (this.cycleNum -1 ) * 24 * 3600 * 1000
      }
    },
    async encode () {
      this.$track.clickEvent('营销推广-营销中心-抽奖宝-报名成功页-下载二维码', '1627892958')
      let a = document.createElement('a')
      a.style.display = 'none'
      a.download = '油站名称'
      a.href = this.qrcode
      document.body.appendChild(a)
      a.click()
    },
    // 查看协议
    openToggleProtocol () {
      this.toggleProtocol = true
    },
    readChange (val) {
      this.haveRead = val
    },
    toCheckPage () {
      this.$track.clickEvent('营销推广-营销中心-抽奖宝-报名成功页-立即查看', '1627892959')
      this.$router.replace({ path: '/promotionAudit/myPromotion', query: { id: 11 } }) // 带上并展示“抽奖宝”的相关审核数据
    },
    goBack () {
      this.$track.clickEvent('营销推广-营销中心-抽奖宝-报名成功页-返回', '1627892960')
      this.$router.replace({ name: 'centerShow' })
    }
  }
}
</script>
<style lang="less" scoped>
  .treasure_con{
    background: #fff;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    .flex_con{
      padding: 10px 32px 0px 32px;
      height: 100%;
      background: #fff;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    .flex1{
      overflow-y: scroll;
      padding-bottom: 112px;
    }
    .back-btn {
      width: 100%;
      height: 58px;
      background: #FFFFFF;
      display: flex;
      align-items: center;
      margin-top: 2px;
      box-shadow: 0px 2px 2px 0px rgba(215, 215, 215, 0.4);
      .el-button {
        width: 120px;
        height: 40px;
      }
    }
    .form_con{
      width: 100%;
      padding: 10px 22px;
      box-sizing: border-box;
      .el-form-item-box{
        display: flex;
        justify-content: flex-start;
        line-height: 40px;
      }
      .form_lable{
        width: 98px;
        text-align: right;
        vertical-align: middle;
        float: left;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        box-sizing: border-box;
        font-weight: 700;
      }
      .form_info{
        color: #333333;
        font-size: 14px;
        font-weight: 400;
      }
      .form_box_shadow{
        max-width: 734px;
        background: #F9FAFC;
        box-sizing: border-box;
        padding: 16px 80px 16px 20px;
        margin-left: 98px;
      }
    }
  }
  .address-container {
    display: flex;
    justify-content: flex-start;
    /deep/.el-select {
      margin-right: 10px;
    }
  }
  .btn-wrap {
    width: calc(100% - 236px - 20px);
    height: 112px;
    padding: 20px 0;
    bottom: 0;
    background: #FFFFFF;
    box-shadow: 0px -2px 8px 0px #F4F7FC;
    position: fixed;
    left: 246px;
    right: 0;
    .flex_center{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .el-button {
      width: 120px;
      margin-top: 10px;
    }
    .protal{
      color: #5087FF;
      font-size: 14px;
      cursor: pointer;
    }
  }

.result_box{
  display: flex;
  padding: 32px 0;
  justify-content: space-around;
  .res_left, .res_right{
    width: 364px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
  }
  .qrcode_title{
    color: #333333;
    font-size: 18px;
    font-weight: 600;
  }
  .qrcode_img{
    width: 240px;
    height: 240px;
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .qrcode_info{
    color: #666666;
    font-size: 14px;
    margin-bottom: 22px;
  }
  .success_icon{
    width: 90px;
    height: 90px;
  }
  .sign_success{
    margin: 24px 0 36px 0;
    color: #222222;
    font-size: 20px;
    font-weight: 600;
  }
  .sign_info{
    color: #666666;
    font-size: 15px;
    line-height: 24px;
  }
  .sign_warn{
    color: #3377FF;
  }
  .btns{
    display: flex;
    justify-content: flex-start;
    margin-top: 32px;
    div{
      flex: 0.5;
    }
  }
  .down-load{
    color: #4B7EFE;
    border: 1px solid #4B7EFE;
    background: #fff;
    padding: 9px 0;
    width: 122px;
    box-sizing: border-box;
    font-weight: 500;
    border-radius: 2px;
    font-size: 14px;
  }
  .res_right{
    box-sizing: border-box;
    padding: 20px 62px;
    background: #F9FAFC;
    text-align: center;
    line-height: 22px;
    color: #666666;
  }
}
p{
  margin: 0;
  padding: 0;
}
.protocol{
  height: 470px;
  overflow-y: scroll;
  font-size: 14px;
  line-height: 26px;
  box-sizing: border-box;
  padding: 10px 54px 54px 54px;
  margin-bottom: 54px
}

/deep/.el-button{
  width: 122px;
}
/deep/ .el-button.el-button--primary{
  color: #fff;
  background: #4B7EFE;
}
</style>